const theme = {
  color1: "#8f0909",
  color2: "#0d5f03",
  color3: "#fbfbfb",
  color4: "#2b2b28",
};

export default theme;
